angular.module('nv.routes', [
  'ui.router',

  // Make sure nv.router.config is first, since it sets config needed for other routes
  'nv.routes.config',

  'nv.routes.auth',
  'nv.routes.main',
  'nv.routes.other',
  'nv.routes.privacy-and-terms',

  // Make sure nv.routes.error-pages is last, since it includes the fallback not-found route
  'nv.routes.error-pages',
]);
